module.exports = __webpack_public_path__ + "static/media/sorry@2x.d4b62e95.png";